export default {
  init() {
    // JavaScript to be fired on the about us page

    jQuery(document).ready(function($){
	    $('.btn-about .style_btn').click(function(){
	    	localStorage.setItem("image_compare_1", $(this).attr('active_sc'));
	      if($(this).hasClass('active')){}
	      else{
	        $('.content-about > div').fadeOut(800);
	        var button_attr = $(this).attr('active_sc');
	        $('.btn-about .style_btn').removeClass('active');
	        $(this).addClass('active');
	        setTimeout(function(){$('.'+button_attr).fadeIn(800)}, 800);
	      }
	    });
	    $('.style_btn[active_sc="'+localStorage.getItem("image_compare_1")+'"]').click();
	  });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js